import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionGuidesPageData } from 'src/app/pages/petitionGuidesArticle/pageContext';
import type { ArticleContentType } from 'src/app/pages/petitionGuidesArticle/pageContext';

type Result = ModelHookResult<
	{
		coreArticles: ReadonlyArray<Readonly<ArticleContentType>>;
	},
	{
		trackArticleClick: () => void;
	}
>;

export function useUsefulArticlesSection(): Result {
	const {
		data: {
			coreArticles,
			article: { slug },
		},
	} = usePetitionGuidesPageData();
	const track = useTracking();

	const filteredCoreArticles = coreArticles
		// Return all core articles, except for current article
		.filter((coreArticle) => coreArticle.slug !== slug)
		// Only show 3 cards
		.slice(0, 3);

	return {
		data: {
			coreArticles: filteredCoreArticles,
		},
		actions: {
			trackArticleClick: () => {
				void track('petition_guides_article_useful_articles_section_click');
			},
		},
	};
}
